

export const Bar = () => {
  return (
    <section>
      <div className='bar_divider_section'>
        <p className='filler_text'>Used by us personally with satisfied users around the world</p>
      </div>
    </section>
  )
}

export default Bar;